import type { ChromeContent } from "../types";

// German copy, drafted here and pending client sign-off on the commercial and
// compliance-sensitive strings. Every such string carries a `[de-review]` marker
// so Phase 13 can assemble the review package by grep rather than by memory —
// an unmarked sensitive string is the failure that package exists to prevent.
export const chrome: ChromeContent = {
  nav: {
    labels: {
      "/": "Startseite",
      "/how-it-works": "So funktioniert's",
      "/platforms": "Plattformen",
      "/tradable-assets": "Handelbare Assets",
      // "Support" is the standard German loanword and is left untranslated;
      // "Kundendienst" reads as a call centre, which this is not.
      "/support": "Support",
    },
    ariaPrimary: "Hauptnavigation",
    ariaMobile: "Mobile Hauptnavigation",
    ariaLegal: "Rechtliches",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
  },

  cta: {
    signIn: "Anmelden",
    // [de-review] The core conversion CTA. "Finanziert werden" is the faithful
    // reading of "Get Funded"; a German prop-firm audience also recognises
    // "Kapital sichern", which is punchier but promises the outcome rather than
    // the evaluation. Sign-off should pick one deliberately.
    getFunded: "Finanziert werden",
  },

  legal: {
    privacy: "Datenschutzerklärung",
    terms: "Allgemeine Geschäftsbedingungen",
    // "AGB" is the standard German abbreviation and is universally read as the
    // full term, so the compact slot collapses to it rather than truncating.
    termsCompact: "AGB",
  },

  notFound: {
    title: "Seite nicht gefunden | Flex Fund",
    description: "Diese Seite existiert nicht. Zurueck zur Flex Fund Startseite.",
    heading: "Diese Seite gibt es nicht.",
    body: "Der Link ist womöglich veraltet oder die Adresse vertippt. Alles andere ist da, wo du es verlassen hast.",
    backHome: "Zurück zur Startseite",
  },

  footer: {
    // [de-review] "Raw Spreads" and "Profit-Splits" are kept as the industry
    // loanwords German traders actually use; translating them ("Rohe Spreads",
    // "Gewinnbeteiligung") reads as a consumer bank rather than a prop firm.
    tagline:
      "Kapital. Raw Spreads. Branchenführende Profit-Splits. Von Tradern für Trader.",
    ariaSocial: "Soziale Netzwerke",
    sections: {
      product: "Produkt",
      company: "Unternehmen",
      legal: "Rechtliches",
    },
    // [de-review] Regulatory risk disclosure. This is the highest-sensitivity
    // string on the site: it appears on every page and is a compliance claim,
    // not marketing copy. German financial disclosures conventionally use
    // "Wertentwicklung" for performance and name the investor explicitly.
    riskWarningLabel: "Risikohinweis.",
    riskWarningBody:
      "Der Handel mit gehebelten Instrumenten birgt erhebliche Risiken und ist möglicherweise nicht für jeden Anleger geeignet. Die vergangene Wertentwicklung ist kein Indikator für zukünftige Ergebnisse.",
    rightsReserved: "ALLE RECHTE VORBEHALTEN",
  },
};
